<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
  <h4 class="modal-title w-100">{{x_titulo}}</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>
<!--Body-->
<div class="modal-body">
  <mdb-card>
        <mdb-card-body>
            <div class="form-row mb-3" *ngIf="false">
                <div class="col-3">Código:</div>
                <div class="col-9">
                  <input mdbInput type="text" maxlength="20"  class="form-control" [(ngModel)]="ParticipanteE.c_participante" readonly>
                </div>
            </div>
            <div class="form-row mb-3">
              <div class="col-3">Nombres:</div>
              <div class="col-9">
                <input mdbInput type="text" maxlength="100"  class="form-control" [(ngModel)]="ParticipanteE.x_nombres" [attr.disabled]="permite_editar ? null : true">
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col-3">Correo:</div>
              <div class="col-9">
                <input mdbInput type="text" maxlength="50"  class="form-control" [(ngModel)]="ParticipanteE.x_correo">
              </div>
          </div>
          <div class="form-row mb-3" *ngIf="muestra_nota">
              <div class="col-3">Nota:</div>
              <div class="col-9">
                <input mdbInput type="text" maxlength="10"  class="form-control" [(ngModel)]="ParticipanteE.x_nota" [attr.disabled]="permite_editar ? null : true">
              </div>
          </div>
          <div class="form-row mb-3"  *ngIf="esupdate">
            <div class="col-3">Nro. Constancia:</div>
            <div class="col-9">
              <input mdbInput [attr.disabled]="id_usuario=='1' ? null : true" type="text" maxlength="50"  class="form-control" [(ngModel)]="ParticipanteE.x_nro_constancia">
            </div>
          </div>
          <div class="form-row mb-3" *ngIf="esupdate">
            <div class="col-3">Estado:</div>
            <div class="col-9">
              <input mdbInput readonly type="text" maxlength="50"  class="form-control" [(ngModel)]="ParticipanteE.x_estado">
            </div>
          </div>



          </mdb-card-body>
    </mdb-card>
    <br *ngIf="esupdate && parti_Estado>21">
    <mdb-card *ngIf="esupdate && parti_Estado>21" >

      <mdb-card-body>
        <div class="form-row mb-3">
            <div class="col-3"><mdb-icon fas icon="file-word"  class="red" size="lg"></mdb-icon> Plantilla:</div>
            <div class="col-9">
            <div *ngIf="seactualizaplantilla" class="custom-file">
                <input type="file" class="custom-file-input" multiple id="importFile" (change)="onFileChange($event.target.files)">
                <label class="custom-file-label" #labelArchivo for="importFile">Seleccionar archivo</label>
            </div>
            <div class="input-group-append">
              <button *ngIf="seactualizaplantilla==false" mdbBtn type="button" (click)="onDescargarArchivo(ParticipanteE.x_uid_doc,'.docx')" size="sm" class="btn btn-blue btn-rounded " mdbWavesEffect>
                <mdb-icon fas icon="download" class="mr-1"></mdb-icon>Descargar</button>
              <button *ngIf="seactualizaplantilla==false && permite_editar" mdbBtn type="button" (click)="onMostrarActualizar(true)" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="sync" class="mr-1"></mdb-icon>Actualizar</button>
              <button *ngIf="seactualizaplantilla" mdbBtn type="button" (click)="onMostrarActualizar(false)" size="sm" class="px-3 btn btn-blue btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="window-close" class="mr-1"></mdb-icon>Cancelar</button>
              <button *ngIf="seactualizaplantilla" mdbBtn type="button" (click)="onActualizarPlantilla()" size="sm" class="px-3 btn btn-teal btn-rounded" mdbWavesEffect>
                <mdb-icon fas icon="upload" class="mr-1"></mdb-icon>Guardar</button>
            </div>
          </div>
        </div>
        <div class="form-row mb-3" *ngIf="(ParticipanteE.c_estado>22)||(id_usuario=='1' && ParticipanteE.x_uid_pdf!=null)">
          <div class="col-3"><mdb-icon fas icon="file-pdf"  class="red" size="lg"></mdb-icon> Constancia:</div>
          <div class="col-9">
          <div class="input-group-append">
            <button [color]="ParticipanteE.c_estado==23 ? 'red':ParticipanteE.c_estado==24?'orange':ParticipanteE.c_estado==25?'lime':'green'"
            mdbBtn type="button" (click)="onDescargarArchivo(ParticipanteE.x_uid_pdf,'.pdf')" size="sm" class="btn btn-rounded " mdbWavesEffect><mdb-icon fas icon="download" class="mr-1"></mdb-icon>Descargar</button>
          </div>
        </div>
      </div>
    </mdb-card-body>
    </mdb-card>
          <br>
          <div class="justify-content-center" style="text-align: center;">
            <button *ngIf="esupdate" mdbBtn (click)="onActualizar()" type="button" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect><mdb-icon fas icon="save" class="mr-1"></mdb-icon>Grabar</button>
            <button *ngIf="esupdate && permite_editar" mdbBtn (click)="onEliminar()" type="button" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect><mdb-icon fas icon="trash" class="mr-1"></mdb-icon>Eliminar</button>
            <button *ngIf="esupdate==false" (click)="onAgregar()" mdbBtn type="button" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect><mdb-icon fas icon="user-plus" class="mr-1"></mdb-icon>Agregar</button>
          </div>

</div>
